import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import { generateResponsiveStyles } from '../../lib/media'

const baseStyles = ({
    justifyContent,
    alignItems,
    flexDirection,
    margin,
}) => css`
    flex-direction: ${flexDirection};
    justify-content: ${justifyContent};
    align-items: ${alignItems};
    margin: ${margin};
`

// define the styling function for the responsive props
const responsiveStyles = generateResponsiveStyles(baseStyles)

const FlexWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-shrink: 0;
    margin: 0;
    position: relative;
    ${baseStyles} // the base styles
    ${responsiveStyles} // the responsive styles
`

FlexWrapper.defaultProps = {
    justifyContent: 'flex-start',
    alignItems: 'start',
    flexDirection: 'row',
    margin: '0',
}

FlexWrapper.propTypes = {
    justifyContent: PropTypes.string,
    alignItems: PropTypes.string,
    flexDirection: PropTypes.string,
    margin: PropTypes.string,
}

export default FlexWrapper
